var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"status-pill small",class:{'red' : !_vm.params.value, 'green' : _vm.params.value}}),_c('span',[_vm._v(_vm._s(_vm.params.value ? "Active" : "Inactive"))])])}
var staticRenderFns = []

export { render, staticRenderFns }